import React from 'react';
import type { ServiceMutationType } from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
export type UpdateServiceType = (
  service: ServiceMutationType,
  pricingInfo: PricingInfoWithScheduleType,
  serviceIds: ReadonlyArray<string>,
  attendeeIds: ReadonlyArray<string>,
) => Promise<any>;
export type DeleteAttendeeChildcareType = (arg0: {
  attendeeId: string;
  pricingInfo: UpsellChildcarePricingInfo;
}) => Promise<any>;
export type AddAttendeeChildcareType = (arg0: {
  attendeeId: string;
  pricingInfo: UpsellChildcarePricingInfo;
  serviceId: string;
}) => Promise<any>;
export type ChildcareContextType = {
  updateService: UpdateServiceType;
  deleteAttendeeChildcare: DeleteAttendeeChildcareType;
  addAttendeeChildcare: AddAttendeeChildcareType;
  currency: string;
  showRentAllSchedules: boolean;
};
export const ChildcareContext = React.createContext<ChildcareContextType>(
  {} as ChildcareContextType,
);
